import * as z from 'zod'

import {
  CopilotFeatureSchema,
  findByIdWithSchema,
  GenericContentSchema,
  GenericGroupSchema,
  parseEntries,
  type GenericSection,
} from '../../../../../brand/lib/types/contentful'

const ComparisonGroupSchema = z.object({
  sys: z.object({
    id: z.string(),
    contentType: z.object({sys: z.object({id: z.literal('genericContent')})}),
  }),
  fields: z.object({
    heading: z.string(),
    htmlId: z.string().optional(),
    content: z.array(CopilotFeatureSchema),
  }),
})

export function toCompareTableContent(section: GenericSection) {
  const tableHeader = findByIdWithSchema(
    section.fields.content,
    'featuresCopilotPlansComparisonHeader',
    GenericContentSchema,
  )
  const featureGroupsEntry = findByIdWithSchema(
    section.fields.content,
    'featuresCopilotPlansComparisonGroups',
    GenericGroupSchema,
  )

  return {
    tableHeader: tableHeader
      ? {
          content: tableHeader,
          columns: parseEntries(tableHeader.fields.content, GenericContentSchema),
        }
      : undefined,
    featureGroups: parseEntries(featureGroupsEntry?.fields.content, ComparisonGroupSchema),
  }
}

export type CompareTableContent = ReturnType<typeof toCompareTableContent>
